<div class="tab-container mat-typography">
  <LOSx-entity-datatable-tab
    entityType="Group"
    [entityId]="entityId"
    [multiRowDatatableFlag]="multiRowDatatableFlag"
    [entityDatatable]="entityDatatable"
  >
  </LOSx-entity-datatable-tab>
</div>
